export interface LanguageType {
  code: string;
  name: string;
  flag: string;
}

export const languages: LanguageType[] = [
  { code: 'ko', name: '한국어', flag: 'kr' }, // 한국어
  { code: 'en', name: 'English', flag: 'us' }, // 영어
  { code: 'fr', name: 'Français', flag: 'fr' }, // 프랑스어
  { code: 'de', name: 'Deutsch', flag: 'de' }, // 독일어
  { code: 'ja', name: '日本語', flag: 'jp' }, // 일본어
  { code: 'zh', name: '中文(简体)', flag: 'cn' }, // 중국어(간체)
  { code: 'zh-TW', name: '中文(繁體)', flag: 'tw' }, // 중국어(繁체)
  { code: 'es', name: 'Español', flag: 'es' }, // 스페인어
  { code: 'it', name: 'Italiano', flag: 'it' }, // 이탈리아어
  { code: 'pt', name: 'Português', flag: 'pt' }, // 포르투갈어
  { code: 'ru', name: 'Русский', flag: 'ru' }, // 러시아어
  { code: 'ar', name: 'العربية', flag: 'sa' }, // 아랍어
  { code: 'hi', name: 'हिन्दी', flag: 'in' }, // 힌디어
  { code: 'th', name: 'ไทย', flag: 'th' }, // 태국어
  { code: 'vi', name: 'Tiếng Việt', flag: 'vn' }, // 베트남어
];
